import cx from 'classnames'

import css from './badge.module.css'
import type { BadgeProps, BadgeSize, BadgeVariant } from './badge.types'

export const styles = {
  base: css.badge,

  icon: (position: BadgeProps['iconPosition']) =>
    cx(css.icon, position === 'right' && css.iconRight),
}

export const sizeStyles: Record<BadgeSize, string> = {
  xs: css.sizeXS,
  s: css.sizeS,
  m: css.sizeM,
  l: css.sizeL,
}

const variantStyles: Record<BadgeVariant, string> = {
  highlight: css.variantHighlight,
  'dark-1': css.variantDark1,
  'dark-2': css.variantDark2,
  'dark-3': css.variantDark3,
  'light-1': css.variantLight1,
  'light-2': css.variantLight2,
  disabled: css.variantDisabled,
  info: css.variantInfo,
  error: css.variantError,
  alert: css.variantAlert,
  success: css.variantSuccess,
}

const shapeStyles = {
  pill: css.shapePill,
  roundedSquare: css.shapeRoundedSquare,
}

/**
 * Returns the styles for the requested visual treatment.
 */
export const getVariantStyles = (variant: BadgeProps['variant']) =>
  variantStyles[variant ?? 'highlight']

/**
 * Returns the styles for the requested silhouette.
 *
 * The rounded-square radius depends on the size, but that dependency is
 * resolved in CSS through `--badge-radius-square` rather than here, so this
 * needs no knowledge of the size axis.
 */
export const getShapeStyles = (shape: BadgeProps['shape']) =>
  shape === 'rounded-square' ? shapeStyles.roundedSquare : shapeStyles.pill
